import {onBeforeUnmount, onMounted, watch, type Ref} from 'vue'
import type {ChartData} from '@/client/mentor/MessagesClient'

export function useAssistantMessageChartLifecycle(
  chartContainer: Ref<HTMLDivElement | null>,
  chartData: Ref<ChartData>,
  hiddenLegendItems: Ref<string[]>,
  drawChart: () => void
) {
  let resizeObserver: ResizeObserver | null = null

  onMounted(() => {
    drawChart()

    resizeObserver = new ResizeObserver(() => {
      drawChart()
    })

    if (chartContainer.value) {
      resizeObserver.observe(chartContainer.value)
    }
  })

  onBeforeUnmount(() => {
    resizeObserver?.disconnect()
  })

  watch(
    () => chartData.value,
    () => {
      hiddenLegendItems.value = []
      drawChart()
    },
    {deep: true}
  )

  watch(hiddenLegendItems, () => {
    drawChart()
  })
}
